<div class="mb-20 location-wrapper">
  <label class="main-label d-block lh-1 text-black">{{'Location' | translate}}</label>

  <mat-form-field class="w-full" >
    <input
      matInput
      [value]="display || ('Click to pick a location' | translate)"
      readonly
      (click)="openDialog()"
      [class.clickable]="!disabled && editable"
      aria-readonly="true"
    />

    <button
      type="button"
      mat-icon-button
      matSuffix
      class="loc-btn"
      (click)="openDialog()"
      [disabled]="disabled || !editable"
      aria-label="Pick location">
      <mat-icon>place</mat-icon>
    </button>
  </mat-form-field>
</div>
